// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"136be26e","453":"f0818a1b"}[chunkId] + ".chunk.js";
};